import React, { useEffect, useState } from "react";

import Table from "../../components/Table";
import Box from "../../components/Box";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import Pagination from "../../components/Pagination";
import ModalCreateCustomer from "../../components/ModalCreateCustomer";

import api from "../../services/api";
import { canEditBrands } from "../../services/auth";

const PER_PAGE = 15;

export const CustomersTab = ({ brandId, companyId, accessMode }) => {
    const [loading, setLoading] = useState(false);

    const [customers, setCustomers] = useState([]);
    const [data, setData] = useState({ header: [], rows: [] });

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);

    const [search, setSearch] = useState('');
    const [appliedSearch, setAppliedSearch] = useState('');

    const [showAdd, setShowAdd] = useState(false);

    useEffect(() => {
        getCustomers();
    }, [currentPage, appliedSearch]);

    // A busca sempre volta para a primeira página: manter a página atual levaria
    // a um resultado vazio quando o filtro devolve menos páginas.
    const applySearch = () => {
        if (currentPage !== 1) setCurrentPage(1);
        setAppliedSearch(search.trim());
    };

    useEffect(() => {
        generateData();
    }, [customers]);

    const getCustomers = () => {
        setCustomers([]);
        setLoading(true);

        api.get(`/brand/${brandId}/customer?per_page=${PER_PAGE}&page=${currentPage}${appliedSearch ? `&search=${encodeURIComponent(appliedSearch)}` : ''}`).then(res => {
            const resources = res.data.resources;
            setCustomers(resources.data ?? []);
            setCurrentPage(resources.current_page);
            setLastPage(resources.last_page);
            setTotalResults(resources.total);
            setHasNextPage(resources.current_page < resources.last_page);
            setHasPrevPage(resources.current_page > 1);
        }).catch(() => {
        }).then(() => setLoading(false));
    };

    const generateData = () => {
        const header = ['Código', 'Nome', 'E-mail', 'Telefone'];
        const rows = [];

        customers.forEach(customer => {
            rows.push({
                data: [
                    customer.code ?? '-',
                    customer.name ?? '-',
                    customer.email ?? '-',
                    customer.phone ?? '-'
                ],
                to: `/customer/edit/${customer.id}`
            });
        });

        setData({ header, rows });
    };

    // Após cadastrar o customer (na empresa vinculada), recarrega a lista da marca.
    const onCustomerStored = () => {
        setShowAdd(false);
        if (currentPage !== 1) {
            setCurrentPage(1);
        } else {
            getCustomers();
        }
    };

    return (
        <div className="brand-customers">
            <ModalCreateCustomer
                show={showAdd}
                close={() => setShowAdd(false)}
                // Quem entra pela marca é sempre cliente: o modal esconde o
                // seletor de marcadores quando o tipo vem definido.
                type={['customer']}
                defaultCompanies={companyId ? [companyId] : undefined}
                brands={brandId ? [brandId] : undefined}
                customerStored={onCustomerStored}
            />

            <div className="brand-tab-head">
                <div>
                    <h2 className="section-title">Pessoas vinculadas à marca</h2>
                    <p className="section-hint">
                        {accessMode === 'restricted'
                            ? 'O site da marca é restrito: só quem está nesta lista consegue entrar.'
                            : 'O site da marca é aberto a qualquer pessoa. Estas são as que estão cadastradas nele.'}
                    </p>
                </div>
                {canEditBrands() &&
                    <Button type={`primary`} size={`small`} text={`Adicionar pessoa`} svg="plus-white" action={() => setShowAdd(true)} />
                }
            </div>

            <div className="brand-list-toolbar">
                <div className="brand-search">
                    <input
                        type="text"
                        placeholder="Buscar por nome ou e-mail"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && applySearch()}
                    />
                    <button onClick={applySearch}>
                        <Icon name="search" size={16} />
                    </button>
                </div>
            </div>

            <Box className={`no-padding`}>
                <Table header={data.header} rows={data.rows} loading={loading} />
            </Box>
            {!loading &&
                <Pagination
                    currentPage={currentPage}
                    lastPage={lastPage}
                    totalResults={totalResults}
                    hasNextPage={hasNextPage}
                    hasPrevPage={hasPrevPage}
                    setCurrentPage={setCurrentPage}
                />
            }
        </div>
    );
};

export default CustomersTab;
